module.exports = __webpack_public_path__ + "static/img/512.0ec8c6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/512.png
// module id = 0N6W
// module chunks = 0